import { Route } from '@angular/router';
import { AppResolver } from './app.resolver';
import { AuthGuard } from './core/services/auth-guard.service';
import { NewVersionReloadGuard } from './core/services/new-version-reload.guard';
import { LayoutComponent } from './layout/layout.component';

export const appRoutes: Route[] = [
    { path: '', pathMatch: 'full', redirectTo: 'home' },

    // Desktop app route — bypasses the default Intranet layout (no nav menu, no header-component).
    // Used by the installed PWA. Browser users on this URL also see the minimal layout, but the
    // route isn't linked from the main nav.
    {
        path: 'desktop',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        resolve: { initialData: AppResolver },
        loadChildren: () =>
            import('src/app/modules/desktop/desktop.module').then(
                (m) => m.DesktopModule
            ),
    },

    // Guests routes
    {
        path: '',
        //canActivate: [NoAuthGuard],
        //canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: '',
                loadChildren: () =>
                    import('src/app/modules/login/login.module').then(
                        (m) => m.LoginModule
                    ),
            },
        ],
    },

    // Auth routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard, NewVersionReloadGuard],
        component: LayoutComponent,
        data: {
            layout: 'default',
        },
        resolve: {
            initialData: AppResolver,
        },
        children: [
            {
                path: '',
                loadChildren: () =>
                    import('src/app/modules/home/home.module').then(
                        (m) => m.HomeModule
                    ),
            },
            {
                path: '',
                loadChildren: () =>
                    import('src/app/modules/clients/clients.module').then(
                        (m) => m.ClientsModule
                    ),
            },
            {
                path: '',
                loadChildren: () =>
                    import('src/app/modules/jobs/jobs.module').then(
                        (m) => m.JobsModule
                    ),
            },
            {
                path: '',
                loadChildren: () =>
                    import('src/app/modules/actions/action.module').then(
                        (m) => m.ActionModule
                    ),
            },
            {
                path: '',
                loadChildren: () =>
                    import('src/app/modules/finance/finance.module').then(
                        (m) => m.FinanceModule
                    ),
            },
            {
                path: '',
                loadChildren: () =>
                    import('src/app/modules/users/users.module').then(
                        (m) => m.UsersModule
                    ),
            },
            {
                path: '',
                loadChildren: () =>
                    import('src/app/modules/admin/admin.module').then(
                        (m) => m.AdminModule
                    ),
            },
            {
                path: '',
                loadChildren: () =>
                    import('src/app/modules/report/report.module').then(
                        (m) => m.ReportModule
                    )
            },
            {
                path: '',
                loadChildren: () =>
                    import('src/app/modules/holidays/holiday.module').then(
                        (m) => m.HolidayModule
                    )
            },
            {
              path: '',
              loadChildren: () =>
                  import('src/app/modules/info/info.module').then(
                      (m) => m.InfoModule
                  ),
          },
          
            {
                path: '',
                loadChildren: () =>
                    import('src/app/modules/toggl/toggl.module').then(
                        (m) => m.TogglModule
                    )
            },
            {
                path: '',
                loadChildren: () =>
                    import('src/app/modules/timer/timer.module').then(
                        (m) => m.TimerModule
                    )
            }
        ],
    },
];
